import React, { Component } from "react";
import { Form, Field } from "react-final-form";
import { connect } from "react-redux";

import Modal from "@components/Modal";
import { removeModal, addModal } from "@store/app/actions";
import { recoverUserPassword } from "@store/user/actions";
import InputText from "@components/Form/InputText";
import Button from "@components/Button";
import {
  composeFormValidators,
  isRequired,
  isEmail,
  hasMaxLength,
} from "@lib/validations";

class ResetPassModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recoverSuccess: false,
    };
  }

  submitRecover = async (values) => {
    const formSubmitResponse = await this.props.recoverUserPassword({
      email: values.email,
    });

    if (formSubmitResponse) {
      this.setState({
        recoverSuccess: true,
      });
    }
  };

  render() {
    return (
      <Modal id={this.props.modalId} header="Recuperare parola" size="small">
        {!this.state.recoverSuccess && (
          <>
            <p className="mb-4 text-sm">
              Introdu adresa de e-mail folosita la crearea contului si iti vom
              trimite indicatii pentru recuperarea parolei
            </p>

            <Form
              onSubmit={this.submitRecover}
              initialValues={{
                email: this.state.email ? this.state.email : "",
              }}
              render={({ handleSubmit, submitting }) => (
                <form onSubmit={handleSubmit}>
                  <Field
                    name="email"
                    type="email"
                    label="Introdu adresa de email"
                    autoComplete="username"
                    component={InputText}
                    required
                    validate={composeFormValidators(
                      isRequired(),
                      isEmail(),
                      hasMaxLength(80)
                    )}
                  />

                  <div className="mt-6 mb-2">
                    <Button
                      title="Recupereaza parola"
                      display="block"
                      variant="primary"
                      type="submit"
                      disabled={submitting}
                    />
                  </div>
                </form>
              )}
            />
          </>
        )}

        {this.state.recoverSuccess && (
          <>
            <p className="m-0 mb-4">
              Instructiunile pentru recuperarea parolei au fost trimise catre
              adresa ta de e-mail. Daca nu primesti mesajul in cateva minute, te
              rugam verifica si in folderele Spam/Junk.
            </p>

            <div className="text-center pt-3 text-sm">
              <button
                className="text-red-brand hover:text-bleu-hover underline"
                onClick={() => {
                  this.props.removeModal();
                  this.setState({
                    recoverSuccess: false,
                  });
                }}
              >
                Inapoi
              </button>
            </div>
          </>
        )}
      </Modal>
    );
  }
}

export default connect(null, {
  removeModal,
  addModal,
  recoverUserPassword,
})(ResetPassModal);
